import React from 'react';

const AdminOrderScreen = () => {
  return <div>AdminOrderScreen</div>;
};

export default AdminOrderScreen;
